export const modalBuscaAtiva = {
  state: () => ({ 
    active: undefined
  }),
  mutations: {  
    setModalBuscaAtiva(state, status){
        state.active = status
    }
  },
  actions: {  
      // Altera o status do modal
      setStatusBuscaAtiva({ commit, status }){
        commit('setModalBuscaAtiva', status)
      }
  },
  getters: { 
    getStatusModalBuscaAtiva: state => {
        return state.active;
    },
   }
}